import { Component, OnInit, OnDestroy } from '@angular/core';
import { Stock } from 'src/app/shared/models/stock.model';
import { Subscription } from 'rxjs';
import { StockListService } from './stock-list.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StockCreateModalComponent } from '../stock-create-modal/stock-create-modal.component';
import Swal from 'sweetalert2'
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Response } from 'src/app/shared/models/response.model';

@Component({
  selector: 'app-stock-list',
  templateUrl: './stock-list.component.html',
  styleUrls: ['./stock-list.component.scss']
})
export class StockListComponent implements OnInit, OnDestroy {

  stocks: Stock[];
  modalOptions: NgbModalOptions;

  paginationOffset: number;
  paginationLimit : number;
  paginationTotal : number;
  paginationMaxPageSize: number;
  searchFilter: string;

  private getAllSubscription: Subscription = null;
  private deleteSubscription: Subscription = null;
  private createSubscription: Subscription = null;
  private editSubscription: Subscription = null;

  constructor(private stockListService: StockListService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.paginationOffset      = 1;
    this.paginationLimit       = 10;
    this.paginationTotal       = 0;
    this.paginationMaxPageSize = 5;
    this.searchFilter          = '';

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.getStocks();
  }

  ngOnDestroy(): void {
    if (this.getAllSubscription !== null) { this.getAllSubscription.unsubscribe(); }
    if (this.deleteSubscription !== null) { this.deleteSubscription.unsubscribe(); }
    if (this.createSubscription !== null) { this.createSubscription.unsubscribe(); }
    if (this.editSubscription   !== null) { this.editSubscription.unsubscribe(); }
  }

  /**
   * Get filtered stock list
   */
  getStocks() {
    this.spinner.show();

    this.getAllSubscription = this.stockListService.resolveStocks(this.searchFilter, this.paginationOffset, this.paginationLimit).subscribe((result: Response) => {
      this.stocks     = result.items;
      this.paginationTotal = result.total;

      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error);
      console.error(error);
    });
  }

  /**
   *
   */
  onCreate(): void {
    const modalRef = this.modalService.open(StockCreateModalComponent, this.modalOptions);
    modalRef.result.then((data) => {

      // Se crea el registro
      this.spinner.show();
      this.createSubscription = this.stockListService.create(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getStocks();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in stock created', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param stock
   */
  onEdit(stock: Stock): void {
    const modalRef = this.modalService.open(StockCreateModalComponent, this.modalOptions);
    modalRef.componentInstance.stock = stock;
    modalRef.result.then((data) => {

      this.spinner.show();
      this.editSubscription = this.stockListService.update(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getStocks();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in stock modify', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param id
   * @param index
   */
  onDelete(id: number, index: number): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.deleteSubscription = this.stockListService.delete(id).subscribe(r => {
          this.stocks.splice(index, 1);
          this.spinner.hide();
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        },
        (error) => {
          this.spinner.hide();
          this.toastr.error(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

  /**
   * 
   * @param term 
   */
  onSearch(term: string) {
    this.searchFilter = term;
    this.getStocks();
  }

  /**
   * 
   */
  onPageChange() {
    this.getStocks();
  }
}
